(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-block"] && !Shopify.designMode) return;
  try {
    $(document).ready(function() {
  $('.opt-label').each(function() {
    var color = $(this).data('swatch');
    if (color) {
      $(this).css('background-color', color);
      $(this).find('.opt-label__text').hide();
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
